import { FormGroup } from "carbon-components-react";
import React from "react";

const ApplicationDisclaimer = () => {
  return (
    <FormGroup legendText="" className="section-header">
      <div className="content">
        <h4>Declaração de exoneração de responsabilidade</h4>
        <p>
          A seguinte declaração de exoneração de responsabilidade descreve os
          termos e condições de inscrição nos nossos programas de formação para
          as Ligações de Consumo. Ao inscrever-se nos nossos programas de
          formação, o utilizador concorda com os seguintes termos:
        </p>

        <p>
          <strong>1. Conteúdo da formação:</strong> O conteúdo fornecido sobre
          os programas de formação que forem apresentados nesta página são
          apenas para fins informativos. Esforçamo-nos por assegurar a exatidão
          e a relevância da informação, mas não garantimos a sua exaustividade
          ou aplicabilidade às necessidades específicas da sua empresa.
        </p>

        <p>
          <strong>2. Responsabilidade:</strong> Não nos responsabilizamos por
          quaisquer danos directos, indirectos, acidentais ou consequenciais
          resultantes da sua participação nos nossos programas de formação. Isto
          inclui, mas não se limita a, perda de lucros ou interrupção temporária
          de negócios.
        </p>

        <p>
          <strong>3. Modificação dos programas de formação:</strong> O Conecta
          Negócios reserva-se o direito de modificar ou descontinuar qualquer
          programa de formação em qualquer altura sem aviso prévio. Isso inclui
          alterações no conteúdo do curso, horários e instrutores.
        </p>

        <p>
          <strong>4. Propriedade intelectual:</strong> Todos os materiais de
          formação, incluindo mas não se limitando a apresentações, folhetos e
          recursos digitais, são propriedade intelectual do Conecta Negócios. A
          reprodução, distribuição ou utilização não autorizada destes materiais
          é proibida.
        </p>
        <h4>Utilização de dados</h4>
        <p>
          Esta secção descreve a forma como recolhemos, utilizamos e protegemos
          os seus dados pessoais:
        </p>

        <p>
          <strong>1. Recolha de dados:</strong> Nós recolhemos dados pessoais
          quando se inscreve nos nossos programas de formação. Estes dados podem
          incluir o seu nome, detalhes de contacto, informações comerciais e
          quaisquer outras informações necessárias para fornecer os nossos
          serviços.
        </p>

        <p>
          <strong>2. Objetivo da recolha de dados:</strong> Os dados pessoais
          que recolhemos são utilizados para os seguintes finalidades:
          <ul>
            <li>
              - Tramitação da sua inscrição e fornecer-lhe acesso aos nossos
              programas de formação.
            </li>
            <li>
              - Para comunicar consigo relativamente à sua participação e
              fornecer actualizações ou informações relacionadas com os
              programas de formação.
            </li>
            <li>
              - Para melhorar os nossos serviços de formação e desenvolver novos
              programas com base em feedback e dados de participação.
            </li>
          </ul>
        </p>
        <p>
          <strong>3. Proteção de dados:</strong> Nós implementamos medidas
          técnicas e organizacionais adequadas para proteger os seus dados
          pessoais contra o acesso não autorizado, alteração, divulgação ou
          destruição. Isto inclui sistemas de armazenamento seguro, encriptação
          e controlos de acesso.
        </p>

        <p>
          <strong>4. Partilha de dados:</strong> Nós não partilhamos os seus
          dados pessoais com terceiros, exceto quando necessário para fornecer
          os serviços de formação ou conforme exigido por lei. Quando a partilha
          de dados é necessária, garantimos que estão em vigor salvaguardas
          adequadas para proteger as suas informações.
        </p>

        <p>
          <strong>5. Retenção de dados:</strong> Conservamos os seus dados
          pessoais durante o tempo necessário para cumprir as finalidades do
          Projecto Conecta Negócios. Quando os seus dados já não forem
          necessários, serão eliminados ou tornados anónimos de forma segura.
        </p>

        <p>
          <strong>6. Informações de contacto:</strong> Se tiver quaisquer
          questões ou preocupações sobre as nossas práticas de utilização de
          dados ou se pretender exercer os seus direitos, contacte-nos através
          de info.consumo@conecta.gov.mz.
        </p>

        <p>
          <strong>
            Ao inscrever-se nos nossos programas de formação, o candidato
            reconhece que leu, compreendeu e concordou com a presente declaração
            de exoneração de responsabilidade e com a política de utilização de
            dados.
          </strong>
        </p>
      </div>
    </FormGroup>
  );
};

export default ApplicationDisclaimer;
